<template>
  <section class="c-section c-section__contents">
    <div class="l-block">
      <div class="l-block__header">
        <TitleSub level="h2">
          <span class="title">上位サイトのタイトル・見出しテキスト</span>
          <Tooltip size="lg">
            SEARCH WRITEが検索結果画面のタイトルから
            該当ページに訪れるユーザーの意図を読み取り、自動で「行きたい」「買いたい」「知りたい」「比べたい」の4種類に分類します。
          </Tooltip>
          <ButtonDownloadSerpsTitles
            :createdAt="createdAt"
            :keyword="keyword"
            :project="project"
            :isCompleteData="isCompleteData"
            :isCompleteSomeData="isCompleteSomeData"
            data-exclude-download
          />
        </TitleSub>
      </div>
      <div class="l-block__content">
        <AiWritingBanner
          class="l-mb-5"
          :projectId="project.id"
          :keyword="keyword"
        />
        <Hint v-if="intent && intent.ratio" class="l-mb-5">
          <p>
            「{{ keyword }}」の検索結果から、このキーワードの検索意図は<Label
              variant="intent"
              :class="'is-' + intent.name"
              >{{ intent.label }}</Label
            >のクエリが上位の{{
              intent.ratio | percentage | roundFloatingPointNumber(1)
            }}%を占めています。
          </p>
        </Hint>
        <Button
          :class="{
            'is-active': checkCount
          }"
          v-if="btnShowAllDisAbled"
          size="w230"
          fsize="f12"
          icon="check"
          radius
          data-exclude-download
          @click="showCheckedOnly"
        >
          チェックした行を表示
        </Button>
        <Button
          :class="{
            'is-active': isActiveAll,
            show_all: true
          }"
          v-if="!btnShowAllDisAbled"
          size="w230"
          fsize="f12"
          icon="check"
          radius
          @click="showAll"
        >
          全ての行を表示
        </Button>
        <table class="c-table">
          <thead>
            <tr>
              <th width="35" data-exclude-download></th>
              <th width="65">順位</th>
              <th width="18%">サイトURL</th>
              <th width="22%">タイトル</th>
              <th width="18%">ディスクリプション</th>
              <template v-if="isAfterHeaderStructuresReleaseDate">
                <th class="structures">見出しタグ構造</th>
              </template>
              <template v-else>
                <th>h1タグ</th>
                <th>h2タグ</th>
                <th>h3タグ</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-if="isLoading">
              <template v-if="isAfterHeaderStructuresReleaseDate">
                <td colspan="6">
                  <LoadingChara variant="inline" size="sm">
                    <template slot="title">
                      データ取得中
                    </template>
                  </LoadingChara>
                </td>
              </template>
              <template v-else>
                <td colspan="8">
                  <LoadingChara variant="inline" size="sm">
                    <template slot="title">
                      データ取得中
                    </template>
                  </LoadingChara>
                </td>
              </template>
            </tr>
            <tr v-else-if="!serpsTopItems.length">
              <template v-if="isAfterHeaderStructuresReleaseDate">
                <td class="l-p-0" colspan="7">
                  <Error variant="inline">
                    <template slot="title">
                      データがありません。
                    </template>
                  </Error>
                </td>
              </template>
              <template v-else>
                <td class="l-p-0" colspan="8">
                  <Error variant="inline">
                    <template slot="title">
                      データがありません。
                    </template>
                  </Error>
                </td>
              </template>
            </tr>
            <ListItemRanksTitle
              v-else
              v-for="(item, index) in data.items"
              :key="index"
              :item="item"
              :index="index"
              :project="project"
              :isAfterHeaderStructuresReleaseDate="
                isAfterHeaderStructuresReleaseDate
              "
              :isActiveAll="isActiveAll"
              :checked="checked"
              :checkedNow="checkedNow"
              @check="updateChecked"
            />
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { INTENT_TYPES } from '@/constants';
import AiWritingBanner from '@/components/aiWriting/AiWritingBanner';
import ButtonDownloadSerpsTitles from '@/components/contentPlans/ButtonDownloadSerpsTitles';
import Error from '@/components/Error';
import Hint from '@/components/Hint';
import Label from '@/components/Label';
import ListItemRanksTitle from '@/components/contentPlans/ListItemRanksTitle';
import LoadingChara from '@/components/LoadingChara';
import TitleSub from '@/components/TitleSub';
import Tooltip from '@/components/Tooltip';
import Button from '@/components/Button';
import apiIntents from '@/api/intents';
import apiProjects from '@/api/projects';
import axios from 'axios';
import utils from '@/utils';

export default {
  props: [
    'createdAt',
    'keyword',
    'project',
    'serpsTopItems',
    'serpsAllItems',
    'isAfterHeaderStructuresReleaseDate',
    'isAfterOwnSiteReleaseDate'
  ],

  components: {
    AiWritingBanner,
    Button,
    ButtonDownloadSerpsTitles,
    Error,
    Hint,
    Label,
    ListItemRanksTitle,
    LoadingChara,
    TitleSub,
    Tooltip
  },

  data() {
    return {
      expiresAt: Date.now() + 10 * 60 * 1000,
      data: {
        items: []
      },
      isLoading: true,
      timeout: null,
      return: [],
      flg: true,
      isActiveAll: true,
      checked: [],
      checkedNow: [],
      btnShowAllDisAbled: true,
      isFiltered: false,
      isCompleteData: false,
      isCompleteSomeData: false
    };
  },

  computed: {
    checkCount() {
      return this.checked.length > 0;
    },
    intent() {
      const keys = Object.keys(INTENT_TYPES);
      const max = keys
        .map(key => {
          const count = this.data.items.filter(item => {
            if (item.intent && item.intent.label && item.intent.label === key) {
              return true;
            }
          }).length;

          return {
            count: count,
            label: INTENT_TYPES[key].label,
            name: INTENT_TYPES[key].name
          };
        })
        .reduce((a, b) => {
          return a.count >= b.count ? a : b;
        });

      return {
        label: max.label,
        name: max.name,
        ratio: max.count / this.serpsTopItems.length
      };
    }
  },

  watch: {
    serpsTopItems: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },

  destroyed() {
    clearTimeout(this.timeout);

    // 非同期通信をキャンセル
    this.flg = false;
    for (let i = 0; i < this.return.length; i++) {
      if (this.return[i]) {
        this.return[i].cancel();
      }
    }
  },

  methods: {
    showAll() {
      this.isActiveAll = true;
      this.btnToggle();
      this.checkedNow = this.checked;
      this.isFiltered = false;
    },
    showCheckedOnly() {
      if (!this.checkCount) {
        return;
      }
      this.isActiveAll = false;
      this.btnToggle();
      this.checkedNow = this.checked;
      this.isFiltered = true;
    },
    btnToggle() {
      this.btnShowAllDisAbled = !this.btnShowAllDisAbled;
    },
    init() {
      if (!this.serpsTopItems.length) {
        return;
      }
      // 配列のコピー
      this.data.items = JSON.parse(JSON.stringify(this.serpsTopItems));
      let siteCheck = false;

      for (let i = 0; i < this.data.items.length; i++) {
        if (this.data.items[i].url.indexOf(this.project.siteUrl) !== -1) {
          siteCheck = true;
          this.data.items[i].isOwnSite = true;
        } else {
          this.data.items[i].isOwnSite = false;
        }
      }

      // 2021年5月の自社情報表示リリース後のデータで、10位以内に自社サイトがない場合のみもう一枠追加
      if (this.isAfterOwnSiteReleaseDate && !siteCheck) {
        this.data.items.unshift({
          url: null,
          rank: null,
          isOwnSite: true
        });
      }

      this.data.items = this.data.items.map((item, index) => {
        // 11位以下の自社サイトURLとrankの取得
        if (!item.rank) {
          for (let i = 0; i < this.serpsAllItems.length; i++) {
            if (
              this.serpsAllItems[i].url.indexOf(this.project.siteUrl) !== -1
            ) {
              item.url = this.serpsAllItems[i].url;
              item.rank = this.serpsAllItems[i].rank;
              break;
            }
          }
        }

        item.description = null;
        item.title = null;
        item.headerStructures = null;
        item.headers = {
          h1: null,
          h2: null,
          h3: null,
          h4: null,
          h5: null
        };

        return item;
      });

      for (let i = 0; i < this.data.items.length; i++) {
        this.getContentPlansTitle(this.data.items[i], i);
      }
    },
    getContentPlansTitle(item, index) {
      // 圏外の場合はユーザーに見れないことを伝える
      if (!item.rank) {
        return;
      }
      // URLの接尾辞が.pdfの場合はTDHの内容が表示できないため、
      // ユーザーに見れないことを伝える
      if (item.url && utils.isPdf(item.url)) {
        let obj = Object.assign({}, this.data.items[index]);
        obj.description = '';
        obj.title = '';
        obj.headers = {
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: []
        };
        obj.contentType = 'pdf';
        obj.isOwnSite = item.isOwnSite;
        // ローディング無効
        this.isLoading = false;
        this.data.items.splice(index, 1, obj);
        return;
      }

      let params = {
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        device: 'desktop',
        url: item.url,
        resource: 'all'
      };
      this.return[index] = axios.CancelToken.source();

      return apiProjects.contentPlans.tdh
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.return[index].token,
          index + 1
        )
        .then(response => {
          let obj = Object.assign({}, this.data.items[index]);
          obj.description = response.data.description;
          obj.title = response.data.title;
          obj.headers = {
            h1: response.data.headers.h1,
            h2: response.data.headers.h2,
            h3: response.data.headers.h3,
            h4: response.data.headers.h4,
            h5: response.data.headers.h5
          };
          obj.contentType = 'html';
          obj.isOwnSite = item.isOwnSite;

          // hタグの構造データを持っていないtdhデータも存在する（旧仕様での取得データ
          if (response.data.headerStructures) {
            obj.headerStructures = response.data.headerStructures;
          }

          this.data.items.splice(index, 1, obj);

          // インテントが取得できていない && タイトルの情報がある場合のみインテントを取得する
          if (!this.data.items[index].intent && response.data.title) {
            this.getIntent(response.data.title, index);
          }
          this.scheduleGetTitles(item, index);

          // 圏外とpdf以外の場合はtitleとdescriptionとheaderStructuresがあること
          this.isCompleteData = this.data.items.every(item => {
            return this.isLoadedTdhItem(item);
          });
          if (this.isCompleteData) {
            this.$emit('completeTdhs');
          }
          // 1件でもデータが取得できてればtrue
          this.isCompleteSomeData = this.data.items.some(item => {
            return this.isNotBlankTdhItem(item);
          });
          this.isLoading = false;
          // グラフのバーの描画に20msのdelayがあるので少しだけ遅らせる
          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit('loadedTdhs');
            }, 20);
          });
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            this.scheduleGetTitles(item, index);
          }
        });
    },
    getIntent(word, index) {
      let params = {
        word: word
      };
      return apiIntents
        .get(params, this.auth.idToken, null, index + 1)
        .then(response => {
          let obj = Object.assign({}, this.data.items[index]);
          obj.intent = response.data;
          this.data.items.splice(index, 1, obj);
          this.isLoading = false;
          // グラフのバーの描画に20msのdelayがあるので少しだけ遅らせる
          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit('loadedTdhs');
            }, 20);
          });
        })
        .catch(error => {});
    },
    scheduleGetTitles(item, index) {
      if (this.flg) {
        if (Date.now() < this.expiresAt) {
          this.timeout = setTimeout(() => {
            this.getContentPlansTitle(item, index);
          }, 30000);
        } else {
          if (this.data.items) {
            for (let i = 0; i < this.data.items.length; i++) {
              const item = this.data.items[index];
              this.data.items.splice(index, 1, {
                ...item,
                description:
                  item.description === null ? undefined : item.description,
                title: item.title === null ? undefined : item.title
              });
            }
          }
        }
      }
    },
    updateChecked(checked) {
      this.checked = checked;

      if (!this.btnShowAllDisAbled && this.checked.length >= 1) {
        this.btnToggle();
      }

      if (this.isFiltered && this.checked.length == 0) {
        this.btnShowAllDisAbled = false;
      }
    },
    isLoadedTdhItem(item) {
      return (
        item.rank === null ||
        item.contentType === 'pdf' ||
        (item.title !== null &&
          item.description !== null &&
          item.headerStructures !== undefined)
      );
    },
    isNotBlankTdhItem(item) {
      return (
        item.title ||
        item.description ||
        (item.headerStructures && item.headerStructures.length)
      );
    }
  }
};
</script>
